import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDownIconXs } from '@lichtblick/icons/svg/chevron-down/chevron-down-xs';
import { forwardRef, useLayoutEffect, useRef, useState } from 'react';
import { FieldFooter } from '../FieldFooter/FieldFooter';
import { Label } from '../Label/Label';
import { ArrowWrapper, IconWrapper, InputRow, Select, StyledSelectInput } from './SelectInput.styles';
const SelectInputInner = ({ allowEmptySelection, className, fieldIcon: FieldIcon, icon, id, isDisabled, label, name, onChange, options, placeholder, statusLabel, statusType, value, ...props }, ref)=>{
    const iconRef = useRef(null);
    const [iconWidth, setIconWidth] = useState();
    const inputId = id || name;
    const labelId = `${inputId}_label`;
    const statusId = `${inputId}_validationMessage`;
    useLayoutEffect(()=>{
        const updateIconWidth = ()=>setIconWidth(iconRef.current?.getBoundingClientRect().width);
        updateIconWidth();
        window.addEventListener('resize', updateIconWidth);
        return ()=>window.removeEventListener('resize', updateIconWidth);
    }, []);
    const handleChange = (event)=>{
        onChange?.(event);
    };
    return /*#__PURE__*/ _jsxs(StyledSelectInput, {
        className: className,
        children: [
            Boolean(label) && /*#__PURE__*/ _jsx(Label, {
                htmlFor: inputId,
                id: labelId,
                isBold: true,
                children: label
            }),
            /*#__PURE__*/ _jsxs(InputRow, {
                $isDisabled: isDisabled,
                $statusType: statusType,
                children: [
                    FieldIcon && /*#__PURE__*/ _jsx(IconWrapper, {
                        ref: iconRef,
                        children: /*#__PURE__*/ _jsx(FieldIcon, {})
                    }),
                    /*#__PURE__*/ _jsxs(Select, {
                        ...props,
                        $paddingLeft: iconWidth,
                        "aria-describedby": statusId,
                        "aria-invalid": statusType === 'error',
                        "aria-labelledby": labelId,
                        disabled: isDisabled,
                        id: inputId,
                        name: name,
                        onChange: handleChange,
                        ref: (instance)=>{
                            if (typeof ref === 'function') {
                                ref(instance);
                            } else if (ref) {
                                ref.current = instance;
                            }
                        },
                        value: value,
                        children: [
                            /*#__PURE__*/ _jsx("option", {
                                hidden: !allowEmptySelection,
                                value: "",
                                children: placeholder
                            }),
                            options.map(({ isHidden, label, value: optionValue })=>/*#__PURE__*/ _jsx("option", {
                                    hidden: isHidden,
                                    value: optionValue,
                                    children: label
                                }, `${optionValue}_${label}`))
                        ]
                    }),
                    !isDisabled && /*#__PURE__*/ _jsx(ArrowWrapper, {
                        children: /*#__PURE__*/ _jsx(ChevronDownIconXs, {})
                    })
                ]
            }),
            Boolean(statusLabel) && /*#__PURE__*/ _jsx(FieldFooter, {
                fieldFooterLabel: statusLabel,
                fieldFooterType: statusType,
                icon: icon,
                id: statusId
            })
        ]
    });
};
export const SelectInput = /*#__PURE__*/ forwardRef(SelectInputInner);

//# sourceMappingURL=SelectInput.js.map